import React, { Component } from "react";
import PropTypes from "prop-types";
import { Container } from "../../../components/atoms/Container";
import { Section } from "../../../components/atoms/Section";
import GuidesPosts from "../../../components/atoms/GuidesPosts";
import BreadCrumbBar from "../../../components/atoms/BreadCrumbBar";
import { GUIDES_TAB_BAR_SLUG, GUIDES_TAB_HEADER_COLOR, GUIDES_TITLE_NAME } from "../../../helpers/constants";
import gpdTandemBike from "../../../assets/images/temp/GPD_tandem-bike.png";
import GuidesHeader from "../../../components/molecules/GuidesHeader";
import urlPatterns from "../../../urls";
import { header } from "../../../styles/variables";
import GuidesTabNavigator from "../../../components/molecules/GuidesTabNavigator";

class GuidesTabMore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showBreadCrumbBar: true,
    };
  }

  async componentDidMount() {
    const { match, history, location } = this.props;
    const { params } = match || {};
    const { slug } = params || {};
    if (slug) {
      const { search } = location || {};
      history.push({
        pathname: urlPatterns.GUIDE_MORE_POST(slug),
        search,
      });
    }
  }

  render() {
    const { history, location } = this.props;

    const { showBreadCrumbBar } = this.state;

    return (
      <>
        <GuidesHeader
          headerIcon={gpdTandemBike}
          headerColor={GUIDES_TAB_HEADER_COLOR.GUIDE_MORE}
          headerTitle={GUIDES_TITLE_NAME.GUIDE_MORE}
          headerDescription="Some handy hints on great food and wine matching."
        />
        <GuidesTabNavigator
          mobileHeaderStyleTop={header.mobileHeight}
          shouldDisappearOnMobile
          backgroundColor={GUIDES_TAB_HEADER_COLOR.GUIDE_MORE}
          urlMore={urlPatterns.GUIDE_MORE}
          location={location}
        />
        <Section xxs>
          {showBreadCrumbBar && (
            <BreadCrumbBar homeLabel="Guides" parentLabel="Food & Wine" location={location} />
          )}
          <Container>
            <GuidesPosts
              history={history}
              filters={`${GUIDES_TAB_BAR_SLUG.GUIDE_MORE}`}
              metaTitle="Food & Wine Pairing Guide: Delicious Tips | Good Pair Days"
              metaDescription="Check out our handy hints on great food and wine matching for classic combos,
              surprising matches and all your favourite foods. Click here »"
              isFromTabMore
              location={location}
            />
          </Container>
        </Section>
      </>
    );
  }
}

GuidesTabMore.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default GuidesTabMore;
